import KYC from "./KYC";

export default KYC;
